import businessService from '@/modules/business/services/businessService';
import logError from '@/utils/logError/logError';

const state = {
  businessSettings: {},
  // The client languages set in business settings (the online profile's supported languages);
  // null until loaded. Empty means only the business language, as in Core's ClientSettingsApi.
  clientLanguages: null,
};

const mutations = {
  setBusinessSettings(state, businessSettings) {
    state.businessSettings = businessSettings;
  },
  setClientLanguages(state, clientLanguages) {
    state.clientLanguages = clientLanguages;
  },
};

const actions = {
  async fetchBusinessSettings({ commit }, businessUid) {
    try {
      const businessSettings = await businessService.fetchBusinessSettings(businessUid);
      if (businessSettings) {
        commit('setBusinessSettings', businessSettings);
      }
    } catch (e) {
      console.error('error', e);
    }
  },
  async fetchClientLanguages({ state, commit }, { force = false } = {}) {
    if (state.clientLanguages && !force) return;
    try {
      const onlineProfile = await businessService.fetchOnlineProfile();
      const languages = onlineProfile?.supported_languages;
      commit('setClientLanguages', Array.isArray(languages) ? languages : []);
    } catch (error) {
      logError('Error fetching client languages', error);
    }
  },
};

const getters = {
  businessSettings: (state) => state.businessSettings,
  businessCategory: (state) => state.businessSettings.profession?.text || '',
  firstDayOfWeek: (state) => state.businessSettings.first_day || 0,
  clientLanguages: (state) => state.clientLanguages || [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
